/* oxlint-disable tailwindcss/no-unknown-classes -- Styles are colocated in home-new.css. */
import type { ReactNode } from "react"

import { useRevealOnce } from "./useRevealOnce"

/**
 * Cascades the rows of a shared illustration in, one after another, the first
 * time it scrolls into view. Wraps the session timelines borrowed from
 * /features/sessions without changing them (styles: `.home-new-cascade`).
 */
export function CascadeReveal({ children }: { children: ReactNode }) {
  const [revealed, ref] = useRevealOnce()

  return (
    <div ref={ref} data-revealed={revealed ? "true" : "false"} className="home-new-cascade w-full">
      {children}
    </div>
  )
}
